import React, { useEffect, useState } from 'react';
import { Spinner, Row, Col } from 'react-bootstrap';
import { getSurveyById } from 'services/surveys';
import PropTypes from 'prop-types';

import SurveyCounters from 'components/app/reports/components/SurveyCounters';
import SurveyResponses from 'components/app/reports/components/SurveyResponses';
import LastCompletedResponse from 'components/app/reports/components/LastCompletedResponse';
import SurveyResponsesByDay from 'components/app/reports/components/SurveyResponsesByDay';
import TopResponseHours from 'components/app/reports/components/TopResponseHours';

const PublicDashboard = ({ surveyId, refreshKey = 0 }) => {
  const [survey, setSurvey] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Cargar la encuesta específica
  const fetchSurvey = () => {
    if (surveyId) {
      setLoading(true);
      setError(null);
      getSurveyById(surveyId)
        .then(response => {
          console.log('getSurveyById', response);
          if (response.result && response.survey) {
            setSurvey(response.survey);
          } else {
            setError('No se pudo cargar la encuesta');
            setSurvey(null);
          }
        })
        .catch(error => {
          console.error('Error al cargar la encuesta:', error);
          setError('Error al cargar la encuesta');
          setSurvey(null);
        })
        .finally(() => setLoading(false));
    } else {
      setError('ID de encuesta no válido');
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSurvey();
  }, [surveyId, refreshKey]);

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" role="status" className="me-2" />
        <span>Cargando reporte...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="border shadow-sm text-center py-3 text-danger">
        {error}
      </div>
    );
  }

  if (!survey) {
    return (
      <div className="border shadow-sm text-center py-3 text-muted">
        No se encontró la encuesta solicitada.
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
      {/* Header con logo */}

      {/* Layout mejorado para desktop manteniendo funcionalidad */}
      <Row className="g-4">
        {/* Contadores y última respuesta - ancho completo */}
        <Col xs={12}>
          <Row className="g-3">
            <Col xs={12} lg={9}>
              <SurveyCounters
                key={`counters-${survey.id}-${refreshKey}`}
                surveyId={survey.id}
              />
            </Col>
            <Col xs={12} lg={3}>
              <LastCompletedResponse
                key={`last-response-${survey.id}-${refreshKey}`}
                surveyId={survey.id}
                className=""
              />
            </Col>
          </Row>
        </Col>

        {/* Gráfico principal - ancho completo */}
        <Col xs={12}>
          <SurveyResponsesByDay
            key={`responses-by-day-${survey.id}-${refreshKey}`}
            surveyId={survey.id}
            className="mb-3"
          />
        </Col>

        {/* Tabla de respuestas - ancho completo */}
        <Col xs={12}>
          <SurveyResponses
            key={`openresponses-${survey.id}-${refreshKey}`}
            surveyId={survey.id}
          />
        </Col>

        {/* Top de horarios - ancho completo */}
        <Col xs={12}>
          <TopResponseHours
            key={`top-hours-${survey.id}-${refreshKey}`}
            surveyId={survey.id}
          />
        </Col>
      </Row>
    </div>
  );
};

PublicDashboard.propTypes = {
  surveyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  refreshKey: PropTypes.number
};

export default PublicDashboard;
